import { TelemetryErrorTagEnum } from '../enums/telemetry-error-tag.enum';
import { ITelemetryErrorCode } from '../interfaces/telemetry-error-code.interface';

export const PRECHECK_GROUP = 'PRECHECK';

export const unknownErrorCode: ITelemetryErrorCode = {
  lookup: 'PC-000-UNKNOWN',
  code: 'PC-000',
  tag: TelemetryErrorTagEnum.UNKNOWN,
  group: PRECHECK_GROUP,
  label: 'UNKNOWN',
};
export const errorCodesList: ITelemetryErrorCode[] = [
  unknownErrorCode,
  {
    code: 'PC-001',
    group: PRECHECK_GROUP,
    label: 'GET COUNTRY LIST FAILED',
    lookup: 'PC-001-GET-COUNTRY-LIST-FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    code: 'PC-002',
    group: PRECHECK_GROUP,
    lookup: 'PC-002-GET-PORT-INFO-FAILED',
    label: 'GET PORT INFO FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-003-GET-SHIP-CODE-MASTER-FAILED',
    code: 'PC-003',
    group: PRECHECK_GROUP,
    label: 'GET SHIP CODE MASTER FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-004-GET-CREW-ASSIGNMENTS-FAILED',
    code: 'PC-004',
    group: PRECHECK_GROUP,
    label: 'GET CREW ASSIGNMENTS FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-005-GET-CREW-EFFECTS-MASTER-FAILED',
    code: 'PC-005',
    group: PRECHECK_GROUP,
    label: 'GET CREW EFFECTS MASTER FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-006-GET-CREW-EFFECTS-V2-FAILED',
    code: 'PC-006',
    group: PRECHECK_GROUP,
    label: 'GET CREW EFFECTS V2 FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-007-GET-CREW-MEMBER-PROFILE-V1-FAILED',
    code: 'PC-007',
    group: PRECHECK_GROUP,
    label: 'GET CREW MEMBER PROFILE V1 FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-008-GET-ENHANCED-SHIP-SIGNONS-FAILED',
    code: 'PC-008',
    group: PRECHECK_GROUP,
    label: 'GET ENHANCED SHIP SIGNONS FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-009-GET-SIGN-ON-POLICIES-ACKNOWLEDGEMENTS-FAILED',
    code: 'PC-009',
    group: PRECHECK_GROUP,
    label: 'GET SIGN ON POLICIES ACKNOWLEDGEMENTS FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-010-GET-ASSIGNMENTS-FAILED',
    code: 'PC-010',
    group: PRECHECK_GROUP,
    label: 'GET ASSIGNMENTS FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-011-POST-UPDATE-BENEFICIARY-AND-EMERGENCY-CONTACTS-FAILED',
    code: 'PC-011',
    group: PRECHECK_GROUP,
    label: 'POST UPDATE BENEFICIARY AND EMERGENCY CONTACTS FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-012-POST-UPDATE-SIGN-ON-POLICIES-ACKNOWLEDGEMENTS-FAILED',
    code: 'PC-012',
    group: PRECHECK_GROUP,
    label: 'POST UPDATE SIGN ON POLICIES ACKNOWLEDGEMENTS FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-013-GET-AGREEMENT-INFO-V3-FAILED',
    code: 'PC-013',
    group: PRECHECK_GROUP,
    label: 'GET AGREEMENT INFO V3 FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-014-GET-TELEPHONE-TYPE-MASTER-FAILED',
    code: 'PC-014',
    group: PRECHECK_GROUP,
    label: 'GET TELEPHONE TYPE MASTER FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-015-GET-SOEA-FROM-EFS-FAILED',
    code: 'PC-015',
    group: PRECHECK_GROUP,
    label: 'GET SOEA FROM EFS FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-016-GET-REPORT-CSV-FAILED',
    code: 'PC-016',
    group: PRECHECK_GROUP,
    label: 'GET REPORT CSV FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-017-GET-EMPLOYEE-HEALTH-CHECK-SURVEY-FAILED',
    code: 'PC-017',
    group: PRECHECK_GROUP,
    label: 'GET EMPLOYEE HEALTH CHECK SURVEY FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-018-POST-UPDATE-HEALTH-CHECK-SURVEY-FAILED',
    code: 'PC-018',
    group: PRECHECK_GROUP,
    label: 'POST UPDATE HEALTH CHECK SURVEY FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-019-GET-CHECK-IN-WORKFLOW-STATE-FAILED',
    code: 'PC-019',
    group: PRECHECK_GROUP,
    label: 'GET CHECK IN WORKFLOW STATE FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-019-GET-CHECK-OUT-WORKFLOW-STATE-FAILED',
    code: 'PC-019',
    group: PRECHECK_GROUP,
    label: 'GET CHECK OUT WORKFLOW STATE FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-020-PUT-UPDATE-WORKFLOW-STATE-FAILED',
    code: 'PC-020',
    group: PRECHECK_GROUP,
    label: 'PUT UPDATE WORKFLOW STATE FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-021-GET-CREW-PHYSIQUE-FAILED',
    code: 'PC-021',
    group: PRECHECK_GROUP,
    label: 'GET CREW PHYSIQUE FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-022-POST-UPDATE-CREW-PHYSIQUE-FAILED',
    code: 'PC-022',
    group: PRECHECK_GROUP,
    label: 'POST UPDATE CREW PHYSIQUE FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-023-POST-RATE-CHECKIN-EXPERIENCE-FAILED',
    code: 'PC-023',
    group: PRECHECK_GROUP,
    label: 'POST RATE CHECKIN EXPERIENCE FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-024-GET-CONTENT-FAQS-FAILED',
    code: 'PC-024',
    group: PRECHECK_GROUP,
    label: 'GET CONTENT FAQS FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-025-GET-CONTENT-DISEASES-FAILED',
    code: 'PC-025',
    group: PRECHECK_GROUP,
    label: 'GET CONTENT DISEASES FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-026-POST-RETRIEVING-RECIPIENT-VIEW-URL-FOR-CREWMEMBER-FAILED',
    code: 'PC-026',
    group: PRECHECK_GROUP,
    label: 'POST RETRIEVING RECIPIENT VIEW URL FOR CREWMEMBER FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-027-POST-RETRIEVING-RECIPIENT-VIEW-URL-FOR-HR-FAILED',
    code: 'PC-027',
    group: PRECHECK_GROUP,
    label: 'POST RETRIEVING RECIPIENT VIEW URL FOR HR FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-028-GET-HEALTH-CHECK-SURVEY-CONTENT-FAILED',
    code: 'PC-028',
    group: PRECHECK_GROUP,
    label: 'GET HEALTH CHECK SURVEY CONTENT FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-029-POST-DELETE-MULTIPLE-WATERMARKS-FAILED',
    code: 'PC-029',
    group: PRECHECK_GROUP,
    label: 'POST DELETE MULTIPLE WATERMARKS FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-030-PUT-ACTIVE-ASSIGNMENT-FAILED',
    code: 'PC-030',
    group: PRECHECK_GROUP,
    label: 'PUT ACTIVE ASSIGNMENT FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-031-GET-SOEA-FROM-SHAREPOINT-FAILED',
    code: 'PC-031',
    group: PRECHECK_GROUP,
    label: 'GET SOEA FROM SHAREPOINT FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-032-GET-CREW-PHOTO-FAILED',
    code: 'PC-032',
    group: PRECHECK_GROUP,
    label: 'GET CREW PHOTO FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-033-PUT-UPDATE-CREW-PHOTO-FAILED',
    code: 'PC-033',
    group: PRECHECK_GROUP,
    label: 'PUT UPDATE CREW PHOTO FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-034-PUT-SYNC-CREW-PHOTO-FAILED',
    code: 'PC-034',
    group: PRECHECK_GROUP,
    label: 'PUT SYNC CREW PHOTO FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-035-GET-HEALTH-CHECK-VACCINES-INFO-FAILED',
    code: 'PC-035',
    group: PRECHECK_GROUP,
    label: 'GET HEALTH CHECK VACCINES INFO FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-036-POST-ADD-VACCINE-CARD-FAILED',
    code: 'PC-036',
    group: PRECHECK_GROUP,
    label: 'POST ADD VACCINE CARD FAILED',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-039-GET-SHIP-SIGNOFFS-FAILED',
    code: 'PC-039',
    group: PRECHECK_GROUP,
    label: 'GET SHIP SIGNOFFS',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-040-GET-SIGN-OFF-POLICIES-ACKNOWLEDGEMENT-FAILED',
    code: 'PC-040',
    group: PRECHECK_GROUP,
    label: 'GET SIGNOFF POLICIES ACKNOWELEDGEMENT',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-041-PUT-SIGN-OFF-POLICIES-ACKNOWLEDGEMENT-FAILED',
    code: 'PC-041',
    group: PRECHECK_GROUP,
    label: 'PUT SIGNOFF POLICIES ACKNOWELEDGEMENT',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-042-PUT-CHECKOUT-WORKFLOW-STATE-FAILED',
    code: 'PC-042',
    group: PRECHECK_GROUP,
    label: 'PUT CHECKOUT WORKFLOW STATE',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
  {
    lookup: 'PC-044-POST-UPDATE-CREW-PROFILE-INFO',
    code: 'PC-044',
    group: PRECHECK_GROUP,
    label: 'POST CREW PROFILE INFO',
    tag: TelemetryErrorTagEnum.ENDPOINT,
  },
];
